<template>
  <div>
    <div class="page-title">Edit HTML Block</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="update"
      btnText="Update HTML Block"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.html-blocks.page";
export default {
  components: { Form },
  metaInfo() {
    const subject = this.form?.title;
    return {
      title: subject ? `Edit “${subject}” HTML Block` : `Edit HTML Block`,
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.HtmlBlock.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
    async update() {
      await this.$api.HtmlBlock.update(this.form);
      this.$router.push("/widgets/html-blocks");
    },
  },
};
</script>

<style></style>
